import type { SVGProps } from 'react';
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.712 3.288a.656.656 0 0 1 0 .928l-6.496 6.496a.656.656 0 1 1-.928-.928l6.496-6.496a.656.656 0 0 1 .928 0Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.288 3.288a.656.656 0 0 1 .928 0l6.496 6.496a.656.656 0 1 1-.928.928L3.288 4.216a.656.656 0 0 1 0-.928Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClose;
